<div
  class="temp-wrap"
  [ngClass]="{ hot: !isCold(), cold: isCold(), empty: isEmpty() }">
  {{ renderValue | number: '1.0-1' | nullDash
  }}<span class="hot-60" *ngIf="!isCold()">
    ({{ waterTempTarget | number: '1.0-1' | nullDash }})</span
  >°C
</div>
